import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { identitySchema } from '@/core/components';

export const laboratorySchema = z.object({
  name: z.string().min(3),
  labChief: identitySchema,
  description: z.string().optional().nullable(),
  websiteLink: z.string().optional().nullable(),
  domain: z.string().optional().nullable(),
  researchTeam: z.string().optional().nullable(),
});

export const defaultLaboratoryValues: DefaultValues<LaboratorySchema> = {
  name: '',
};

export type LaboratorySchema = z.infer<typeof laboratorySchema>;
